import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2051Status: 'idle',
    startProcess2051Error: undefined as any,
    loadUserParamsProcess2051Status: 'idle',
    loadUserParamsProcess2051Error: undefined as any,

    process2051List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2051 = createAsyncThunk('process2051Slice/startProcess2051', async ({ process2051 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2051/`,
        prepareData(process2051),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2051Status } = getState().process2051Slice
        return startProcess2051Status !== 'pending'
    }
})

export const loadUserParamsProcess2051 = createAsyncThunk('process2051Slice/loadUserParamsProcess2051', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2051/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2051Status } = getState().process2051Slice
        return loadUserParamsProcess2051Status !== 'pending'
    }
})

const Process2051Slice = createSlice({
    name: 'process2051Slice',
    initialState,
    reducers: {
        resetstartProcess2051: (state) => {
            state.job = undefined
            state.startProcess2051Error = undefined
        },
        resetstartProcess2051Error: (state) => {
            state.startProcess2051Error = undefined
        },
        resetloadUserParamsProcess2051: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2051Error = undefined
        },
        resetloadUserParamsProcess2051Error: (state) => {
            state.loadUserParamsProcess2051Error = undefined
        },
        removeFromProcess2051ListById: (state, action) => {
            state.process2051List = state.process2051List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2051ListByIds: (state, action) => {
            state.process2051List = state.process2051List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2051List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2051Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2051List = []
            state.startProcess2051Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2051.pending, (state) => {
            state.startProcess2051Status = 'pending'
            state.startProcess2051Error = undefined
        })
        builder.addCase(startProcess2051.fulfilled, (state, action) => {
            state.startProcess2051Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2051.rejected, (state, action) => {
            state.startProcess2051Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2051Error = action.error.message
            } else {
                state.startProcess2051Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2051.pending, (state) => {
            state.loadUserParamsProcess2051Status = 'pending'
            state.loadUserParamsProcess2051Error = undefined
        })
        builder.addCase(loadUserParamsProcess2051.fulfilled, (state, action) => {
            state.loadUserParamsProcess2051Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2051.rejected, (state, action) => {
            state.loadUserParamsProcess2051Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2051Error = action.error.message
            } else {
                state.loadUserParamsProcess2051Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2051,
    resetstartProcess2051Error,
    resetloadUserParamsProcess2051,
    resetloadUserParamsProcess2051Error,
    removeFromProcess2051ListById,
    removeFromProcess2051ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2051Slice.actions
export default Process2051Slice.reducer
